/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-08",
    versionChannel: "nightly",
    buildDate: "2025-05-08T00:07:01.779Z",
    commitHash: "4c68a993246992f247a124cd0f7ee26d9cea274e",
};
